import React from 'react';

const RelatedGames = ({ games, small }) => {
  const displayedGames = small ? games.slice(0, 2) : games;
  return <div className="relative">
    <div className="flex w-full items-center max-w-6xl m-auto px-4 sm:px-16">
      <div className="grid-cols-1 sm:grid-cols-2 grid gap-6 w-full py-16 sm:py-12">
        {displayedGames.map((game, index) => <a href={game.path} key={index} style={{ paddingBottom: '56.25%' }} className="relative">
          <div style={{ boxShadow: '0 4px 0 0 rgba(5, 21, 34, .29)' }} className="group absolute inset-0 rounded-lg overflow-hidden">
            <img alt={game.title} className="transform duration-300 group-hover:scale-105 object-cover h-full w-full" src={game.image} />
            <span className="absolute bottom-0 left-0 bg-white leading-none rounded-tr-lg">
              <img className="h-16 p-2" alt="Spel" src="/assets/category-icons/game.svg" />
            </span>
          </div>
        </a>)}
      </div>
    </div>
  </div>;
};

export default RelatedGames;
